/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React from "react";
import Grid from "@mui/material/Grid";
import { dateFieldDefault, requiredValidator } from "@/src/services/validationRules";
import ValidatorTextField from "@/src/components/FormFields/ValidatorTextField";
import FormLegend from "@/src/components/Form/Common/FormLegend/FormLegend";
import NumberFieldConfigured from "@/src/components/Form/ConfiguredFormElements/NumberFieldConfigured/NumberFieldConfigured";
import { AbstractCase } from "@/src/types/Entities/AbstractCase";
import wizardStyle from "@/src/components/Form/wizardStyle";

type PensionInsuranceProps = {
  path: string;
  index: number;
  product: AbstractCase;
};

export default function PensionInsurance({ path, index, product }: PensionInsuranceProps) {
  return (
    <>
      <Grid sx={wizardStyle.gridTopSpaced} size={12}>
        <FormLegend>Geben Sie hier bitte weitere Details zur {index + 1}. Versicherung an.</FormLegend>
      </Grid>
      <Grid size={12}>
        <ValidatorTextField
          name={path + ".name"}
          label="Name der Versicherung"
          validators={[requiredValidator("Bitte geben Sie den Namen der Versicherung an")]}
        />
      </Grid>
      <Grid size={12}>
        <ValidatorTextField
          name={path + ".policyHolder"}
          label="Versicherungsnehmer"
          validators={[requiredValidator("Bitte geben Sie den Namen des Versicherungsnehmers an")]}
        />
      </Grid>
      <Grid size={12}>
        <ValidatorTextField
          name={path + ".date"}
          label="Datum des Versicherungsvertrags"
          validators={[requiredValidator("Bitte geben Sie das Datum an"), dateFieldDefault]}
        />
      </Grid>
      <NumberFieldConfigured caseData={product} fieldPath={path + ".value"} fieldType={"money"} required numberType={"float"} />
    </>
  );
}
